import { inject, Injectable } from '@angular/core';
import { CanDeactivate, Router } from '@angular/router';
import { Observable } from 'rxjs';

export type CanComponentDeactivate = {
    canDeactivate: () => Observable<boolean> | boolean;
};

export const IGNORE_CAN_DEACTIVATE_GUARD = 'ignoreCanDeactivateGuard';

@Injectable({
    providedIn: 'root'
})
export class CanDeactivateGuard implements CanDeactivate<CanComponentDeactivate> {
    private readonly router = inject(Router);

    public canDeactivate(component: CanComponentDeactivate) {
        if (this.router.getCurrentNavigation()?.extras?.state?.[IGNORE_CAN_DEACTIVATE_GUARD]) {
            return true;
        }

        return component.canDeactivate ? component.canDeactivate() : true;
    }
}
